<template>
  <div>
    <div class="title">
      网页title设置：{{ title }}
      <el-button type="primary" size="mini" @click="editSummary(title, 0, 500)"
        >编辑</el-button
      >
    </div>

    <div class="head"><img src="@/assets/image/home/head.png" alt="" /></div>
    <div class="banner">
      <div id="head-swiper" class="swiper-container">
        <div class="swiper-wrapper">
          <template v-for="item in banner">
            <div
              class="swiper-slide sincerity_warp-data"
              v-if="item.imageUrl"
              :key="item.id"
              :style="`background-image: url(${$utils.fileUrl(item.imageUrl)})`"
            ></div>
          </template>
        </div>
      </div>
      <span class="tips">图片尺寸：1920*540px 格式：jpg、png</span>
      <div class="edit-banner">
        <h2>编辑页头banner</h2>
        <ul>
          <li v-for="item in banner" :key="item.id">
            <div
              :style="
                item.imageUrl
                  ? `background-image: url(${$utils.fileUrl(item.imageUrl)})`
                  : ''
              "
            ></div>
            <div>
              <div>
                <el-button size="small" type="primary" @click="selectFile(item)"
                  >编辑</el-button
                >
              </div>
              <div>
                <el-button size="small" type="danger" @click="delBanner(item)"
                  >删除</el-button
                >
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="body_warp">
      <div class="text-head">
        <h2>
          <el-input
            v-model="content01"
            maxlength="30"
            show-word-limit
            placeholder="请输入内容"
          ></el-input>
        </h2>
        <li>
          <el-input
            resize="none"
            rows="2"
            v-model="content02"
            type="textarea"
            placeholder="请输入内容"
            maxlength="100"
            show-word-limit
          ></el-input>
        </li>
        <li>
          <el-button type="primary" size="mini" @click="save">保存</el-button>
        </li>
      </div>

      <img src="@/assets/image/home/activity.png" alt="" />
    </div>

    <!-- banner -->
    <el-dialog
      v-model="banner_dialog"
      title="banner图片"
      width="500px"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          :model="bannerForm"
          :rules="bannerRules"
          size="mini"
          ref="bannerForm"
          label-width="100px"
          label-position="right"
        >
          <el-form-item label="图片：" prop="imageUrl">
            <div class="upload-img">
              <label
                for="file"
                :style="
                  bannerForm.imageUrl
                    ? `background-image: url(${$utils.fileUrl(
                        bannerForm.imageUrl
                      )})`
                    : ''
                "
              >
                <i class="el-icon-plus" v-if="!bannerForm.imageUrl"></i>
                <input type="file" id="file" @change="upload($event)" />
              </label>
              <ul>
                <li>图片尺寸：1920*540</li>
                <li>图片格式：jgp、png</li>
              </ul>
            </div>
          </el-form-item>
          <el-form-item label="链接：" prop="imageLink">
            <el-input
              placeholder="链接"
              v-model="bannerForm.imageLink"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="图片说明：">
            <el-input
              rows="5"
              resize="none"
              type="textarea"
              placeholder="简介"
              maxlength="500"
              show-word-limit
              v-model="bannerForm.imageExplain"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="banner_dialog = false" size="mini">取消</el-button>
          <el-button @click="submit_banner" type="primary" size="mini"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banner: {},
      title: "",
      content01: "",
      content02: "",
      banner_dialog: false,
      bannerForm: {
        id: null,
        imageUrl: "",
        imageExplain: "",
        imageLink: "",
        pageType: null,
        imageSeq: null,
      },
      bannerRules: {
        imageUrl: [
          { required: true, message: "请选择banner图片", trigger: "change" },
        ],
        imageLink: [
          {
            required: false,
            pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
            message: "格式不正确",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    delBanner(item) {
      if (!item.imageUrl) return;
      let count = 0;
      this.banner.forEach((item) => {
        if (!item.imageUrl) {
          count++;
        }
      });
      if (count === 2) {
        this.$message.warning("还剩一张图片，不能全都删除！");
      } else {
        item.imageUrl = "";
      }
    },
    async getData() {
      try {
        const res = await this.$api.pageManage.getData(17);
        if (res.code === 10200) {
          this.banner = res.data.banner;
          this.content01 = res.data.content01;
          this.content02 = res.data.content02;
          this.title = res.data.webTitle.content;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {}
    },
    // 编辑概述
    editSummary(content, type, limit = 30) {
      this.$prompt("请输入内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: content,
        inputValidator: (value) => {
          if (!value) return "请输入内容";
          else if (value.length > limit) return `最多输入${limit}个字符`;
          else return true;
        },
      })
        .then(({ value }) => {
          const params = {
            content: value,
            pageType: 17,
            pageLocation: type,
          };
          this.setSummary(params);
        })
        .catch(() => {});
    },
    // 保存概述
    async setSummary(params) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.pageManage.setSummary(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData();
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    selectFile(data) {
      this.bannerForm = { ...data };
      this.banner_dialog = true;
    },
    async setBanner(data) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = JSON.stringify(data);
          const res = await this.$api.pageManage.home.setBanner(params);
          this.$loading.done();
          this.loading = false;
          if (res.code === 10200) {
            this.getData();
            this.$message.success("保存成功！");
            this.banner_dialog = false;
          } else {
            this.$message.error(res.msg);
          }
        } catch (err) {
          this.$loading.done();
          this.loading = false;
        }
      }
    },

    upload(e) {
      e = e.target || e.srcElement;
      const files = e.files[0];
      if (e.value == "") {
        return;
      }

      let args = files.name.split(".");
      let nameType = args[args.length - 1];
      const fileType = ["jpg", "png"];

      if (fileType.indexOf(nameType) < 0) {
        this.$message.warning(`不支持上传${nameType}格式的文件`);
        return;
      }

      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        this.$api
          .uploadFile(3, files)
          .then((res) => {
            this.$message.success("上传成功");
            e.value = "";
            this.$loading.done();
            this.loading = false;
            this.bannerForm.imageUrl = res;
            this.$refs["bannerForm"].validateField("imageUrl");
          })
          .catch((err) => {
            e.value = "";
            this.$loading.done();
            this.loading = false;
          });
      }
    },
    submit_banner() {
      this.$refs["bannerForm"].validate((valid) => {
        if (valid) {
          const params = this.banner.map((item) => {
            if(item.imageSeq===this.bannerForm.imageSeq){
              return {...this.bannerForm}
            }else{
            return { ...item };
            }
          });
          this.setBanner(params);
        } else {
          return false;
        }
      });
    },
    async save() {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            bannerList: this.banner,
            content1: this.content01,
            content2: this.content02,
            pageType: 17,
          };
          const res = await this.$api.pageManage.setSpecialHome(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData();
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      this.swiper = new this.Swiper("#head-swiper", {
        effect: "fade",
        autoplay: 5000,
        loop: true,
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.title {
  padding: 24px;
  font-size: 0.875rem;
  margin-bottom: 24px;
  background-color: #ffffff;

  .el-button {
    margin-left: 40px;
  }
}
.head {
  display: flex;
  img {
    width: 100%;
  }
}
.banner {
  height: 650px;
  position: relative;

  .head {
    left: 0;
    top: 0;
    right: 0;
    z-index: 999;
    position: absolute;
  }

  .swiper-container {
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: #ffffff;

    .sincerity_warp-data {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .head_warp {
    width: 100%;
    z-index: 100;
    margin: 0 auto;
    padding-top: 180px;
    position: relative;

    h2 {
      text-align: center;
      font-weight: 500;
      color: #ffffff;
      font-size: 2.5rem;
      line-height: 60px;
    }

    h4 {
      text-align: center;
      font-weight: 300;
      margin-top: 23px;
      color: #ffffff;
      font-size: 1.5rem;
      margin-bottom: 25px;
    }

    .main-search {
      padding: 0 50px;
      overflow: hidden;
      max-width: 1100px;
      border-radius: 4px;
      margin: 55px auto 0 auto;

      .search-tab {
        height: 48px;
        display: flex;
        margin-bottom: 24px;
        justify-content: center;
        border-top-right-radius: 4px;
        li {
          width: 90px;
          height: 48px;
          cursor: pointer;
          color: #ffffff;
          line-height: 40px;
          text-align: center;
          font-size: 1.125rem;
          position: relative;

          &:not(:last-child) {
            margin-right: 25px;
          }

          img {
            top: 0;
            left: 0;
            opacity: 0;
            transform: scale(0);
            position: absolute;
            transition: $--all-transition;
          }

          span {
            z-index: 999;
            position: relative;
          }

          &[class="active"] {
            color: #ffffff;
            // background-color: $--color-primary;

            img {
              opacity: 1;
              transform: scale(1);
            }
          }
        }
      }

      .search-input {
        height: 56px;
        overflow: hidden;
        padding-left: 57px;
        position: relative;
        border-radius: 4px;
        padding-right: 130px;
        background-color: #ffffff;
        input {
          height: 56px;
          width: 100%;
          border: none;
          box-sizing: border-box;
          padding: 0 60px 0 0;
        }

        button {
          top: 0;
          right: 0;
          width: 130px;
          height: 56px;
          border: none;
          color: #ffffff;
          font-size: 1.125rem;
          position: absolute;
          background-color: $--color-primary;
        }

        i {
          top: 50%;
          left: 24px;
          cursor: pointer;
          font-size: 1.5rem;
          position: absolute;
          transform: translateY(-50%);
        }

        span {
          top: 50%;
          right: 154px;
          cursor: pointer;
          position: absolute;
          font-size: 0.875rem;
          transform: translateY(-50%);
          color: $--color-text-regular;
        }

        ::-webkit-input-placeholder {
          /* WebKit browsers */
          color: $--color-text-secondary;
          font-size: 1rem;
        }

        ::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: $--color-text-secondary;
          font-size: 1rem;
        }

        :-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: $--color-text-secondary;
          font-size: 1rem;
        }
      }
    }

    .records {
      margin-top: 24px;

      li {
        max-width: 1000px;
        height: 14px;
        margin: 0 auto;
        line-height: 14px;
        color: #ffffff;
        text-align: center;
        font-size: 0.875rem;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;

        span {
          height: 14px;
          cursor: pointer;
          line-height: 14px;
          i {
            cursor: pointer;
            color: $--color-primary;
          }

          &:not(:last-child) {
            margin-right: 15px;
          }
        }
      }
    }
  }

  .edit-banner {
    top: 200px;
    right: 40px;
    z-index: 101;
    width: 360px;
    padding: 20px;
    position: absolute;
    box-sizing: border-box;
    border: 1px solid $--border-color-base;
    background-color: rgba(255, 255, 255, 0.8);

    h2 {
      font-size: 1.125rem;
      text-align: center;
      margin-bottom: 20px;
    }

    ul {
      li {
        display: flex;

        &:not(:last-child) {
          margin-bottom: 15px;
        }

        input {
          display: none;
        }

        & > div {
          &:first-child {
            flex: 1;
            height: 80px;
            margin-right: 15px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          }

          &:last-child {
            .el-button {
              width: 80px;
            }
            & > div {
              &:first-child {
                margin-bottom: 16px;
              }
            }
          }
        }
      }
    }

    .save {
      margin-top: 20px;
      text-align: center;

      .el-button {
        width: 120px;
      }
    }
  }

  .tips {
    top: 100px;
    left: 50px;
    z-index: 9;
    padding: 3px 10px;
    position: absolute;
    font-size: 0.75rem;
    background-color: $--color-warning;
  }
}
.body_warp {
  max-width: 1400px;
  margin: 0 auto;

  .text-head {
    margin: 0 auto;
    max-width: 770px;
    text-align: center;
    padding: 70px 0 50px 0;
    h2 {
      font-weight: 500;
      margin-bottom: 15px;
      font-size: 1.875rem;
    }

    li {
      line-height: 30px;
      color: $--color-text-regular;

      &:last-of-type {
        padding: 10px 0;
        .el-button {
          width: 120px;
        }
      }
    }
  }

  & > img {
    width: 100%;
  }
}

.upload-img {
  display: flex;
  label {
    width: 192px;
    height: 54px;
    cursor: pointer;
    line-height: 54px;
    text-align: center;
    margin-right: 10px;
    display: inline-block;
    box-sizing: border-box;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid $--border-color-base;
    input {
      display: none;
    }
  }
  li {
    font-size: 0.75rem;
  }
}
</style>